/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortfolioStatistic } from './PortfolioStatistic';
import {
    PortfolioStatisticFromJSON,
    PortfolioStatisticFromJSONTyped,
    PortfolioStatisticToJSON,
    PortfolioStatisticToJSONTyped,
} from './PortfolioStatistic';
import type { Portfolio } from './Portfolio';
import {
    PortfolioFromJSON,
    PortfolioFromJSONTyped,
    PortfolioToJSON,
    PortfolioToJSONTyped,
} from './Portfolio';

/**
 * 
 * @export
 * @interface PortfolioResponse
 */
export interface PortfolioResponse {
    /**
     * 
     * @type {Portfolio}
     * @memberof PortfolioResponse
     */
    portfolioModel: Portfolio;
    /**
     * 
     * @type {number}
     * @memberof PortfolioResponse
     */
    accountCount: number;
    /**
     * 
     * @type {Array<PortfolioStatistic>}
     * @memberof PortfolioResponse
     */
    statsByStatus: Array<PortfolioStatistic>;
}

/**
 * Check if a given object implements the PortfolioResponse interface.
 */
export function instanceOfPortfolioResponse(value: object): value is PortfolioResponse {
    if (!('portfolioModel' in value) || value['portfolioModel'] === undefined) return false;
    if (!('accountCount' in value) || value['accountCount'] === undefined) return false;
    if (!('statsByStatus' in value) || value['statsByStatus'] === undefined) return false;
    return true;
}

export function PortfolioResponseFromJSON(json: any): PortfolioResponse {
    return PortfolioResponseFromJSONTyped(json, false);
}

export function PortfolioResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'portfolioModel': PortfolioFromJSON(json['portfolioModel']),
        'accountCount': json['accountCount'],
        'statsByStatus': ((json['statsByStatus'] as Array<any>).map(PortfolioStatisticFromJSON)),
    };
}

export function PortfolioResponseToJSON(json: any): PortfolioResponse {
    return PortfolioResponseToJSONTyped(json, false);
}

export function PortfolioResponseToJSONTyped(value?: PortfolioResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'portfolioModel': PortfolioToJSON(value['portfolioModel']),
        'accountCount': value['accountCount'],
        'statsByStatus': ((value['statsByStatus'] as Array<any>).map(PortfolioStatisticToJSON)),
    };
}

